import { render, staticRenderFns } from "./VSearchItems.vue?vue&type=template&id=48dabda5"
import script from "./VSearchItems.vue?vue&type=script&lang=js"
export * from "./VSearchItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports